/**
 * Mobile.js handles mobile/responsive related functions useful across
 * the app.
 */

import $ from 'jquery'

import constants from './constants'
import layoutManager from './layout-manager'

// These are expensive operations and for large report exports it saves a
// significant amount of CPU cycles to not do the calculation
const calculate = calculation => layoutManager.export ? false : calculation()

var mobile = {
	isMobileWidth: function() {
		return calculate(() => $(window).width() <= constants.MOBILE_WIDTH_BREAKPOINT)
	},

	isMobileHeight: function() {
		return calculate(() => $(window).height() <= constants.MOBILE_HEIGHT_BREAKPOINT)
	},

	isMobileOrientation: function() {
		return calculate(() => this.isMobileWidth() || this.isMobileHeight())
	},

	isMobileMenuVisible: function () {
		return calculate(() => $('html').hasClass('is-mobile-menu-visible'))
	},

	isTouchMoving: function() {
		return calculate(() => $('body').hasClass('is-touch-moving'))
	}
}

export default mobile

mobile.__filename__ = 'components/mobile.js'
